import { render, staticRenderFns } from "./ShopInfoLog.vue?vue&type=template&id=23c29859&scoped=true"
import script from "./ShopInfoLog.vue?vue&type=script&lang=js"
export * from "./ShopInfoLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c29859",
  null
  
)

export default component.exports